import { CspConfigs } from "components/Integrations/types";

import { customIamAssessmentInstaller } from "./iam-assessment";
import { customResourceInstaller } from "./resource";
import { CustomIntegrationInstaller } from "./types";

export const customIntegrationInstaller = (
  cspConfigs: Omit<CspConfigs, "self-hosted">
): CustomIntegrationInstaller => ({
  base: {},
  "iam-write": customResourceInstaller(cspConfigs),
  "iam-assessment": customIamAssessmentInstaller,
});
